"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Document = function Document(_ref) {
  var title = _ref.title,
      description = _ref.description,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["title", "description", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "aria-hidden": !title,
    "aria-labelledby": "DocumentTitle DocumentDescription",
    height: height,
    preserveAspectRatio: "none",
    role: "img",
    viewBox: "0 0 24 24",
    width: width
  }, rest), /*#__PURE__*/_react["default"].createElement("title", {
    id: "DocumentTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("desc", {
    id: "DocumentDescription"
  }, description), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(1 1)",
    d: "M17.958 8.375c.028.083.042.208.042.375v10.167c0 .277-.083.527-.25.75-.167.222-.375.333-.625.333H7c-.25 0-.48-.111-.688-.333a1.07 1.07 0 0 1-.312-.75V4.958c0-.25.104-.472.313-.666A.982.982 0 0 1 7 4h6.667c.166 0 .291.028.375.083.166.084.264.14.291.167l3.459 3.833c.083.084.139.18.166.292zm-3.916-2.417v2.625h2.416l-2.416-2.625zM7.333 18.667h9.334v-8.75h-2.792c-.306 0-.576-.118-.813-.354a1.117 1.117 0 0 1-.354-.813V5.333H7.333v13.334z",
    fillRule: "evenodd"
  }));
};

Document.defaultProps = {
  description: '',
  height: 24,
  title: null,
  width: 24
};
Document.propTypes = {
  description: _propTypes["default"].string,
  height: _propTypes["default"].number,
  title: _propTypes["default"].string,
  width: _propTypes["default"].number
};
var _default = Document;
exports["default"] = _default;